exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\n.main-menu-button {\n  position: absolute;\n  left: 0; }\n\n.title {\n  text-align: center; }\n\n.export-buttons {\n  width: 50vw;\n  margin: 0 auto;\n  text-align: left; }\n\n.export-button {\n  margin: 2vh;\n  border: 1px #000055 solid;\n  color: #000055; }\n\n.export-button:hover {\n  color: #3333cc; }\n\n/* loader\n------------------------------------------------------------ */\n.loader {\n  display: none;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.7); }\n  .loader .loading-text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    color: #ffffff;\n    font-size: 60px;\n    text-align: center;\n    transform: translate(-50%, -50%); }\n  .loader.show {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/export-docx-page/export-docx-page.scss
// module id = ../../../../../src/app/admin-area/containers/export-docx-page/export-docx-page.scss
// module chunks = main